import TRADE2_EXT_1 from "./TRADE2_EXT_1";
export default {
  TRADE2_EXT_1,
};
